import React from 'react'
import { MenuItem, TextField } from '@mui/material'

const Menu = ({ value: currentValue, onChange, languages, className = '' }) => (
  <TextField
    select
    value={currentValue}
    onChange={({ target: { value } }) => onChange(value)}
    fullWidth
    className={className}
    inputProps={{ 'data-test': 'article-translate-menu' }}
    SelectProps={{ SelectDisplayProps: { 'data-test': 'article-translate-selector' } }}
  >
    {languages.map(({ label, value }, index) => (
      <MenuItem
        key={value}
        value={value}
        data-test={`article-translate-menu-item-${index}`}
      >
        {label}
      </MenuItem>
    ))}
  </TextField>
)

export default Menu
